import axiosClient from './axiosClient';

export const checkChangeApi = (id?:any) => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/documents/api/quotes-document/${id}/version-changed`;
    return axiosClient.get(url);
};

export const checkMultipleChangeApi = (dataParam?: any) => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/documents/api/quotes-document/version-changes${dataParam}`;
    return axiosClient.get(url);
};
